/**
 * A leftover internal list some workspaces still carry. It holds no leads
 * anyone chose, so neither the app nor Clu lists it.
 */
const INTERNAL_LIST_NAME = '__system_default__';

export function isInternalList(list: unknown): boolean {
  return (
    typeof list === 'object' &&
    list !== null &&
    (list as { name?: unknown }).name === INTERNAL_LIST_NAME
  );
}
